import { render, staticRenderFns } from "./BalanceAdjustment.vue?vue&type=template&id=e2c5c696&scoped=true&"
import script from "./BalanceAdjustment.vue?vue&type=script&lang=js&"
export * from "./BalanceAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c5c696",
  null
  
)

export default component.exports